import { useState } from "react";

export default function Section9() {
    const [isOpen, setIsOpen] = useState(new Array(9).fill(false));

    const handleFaq = (index) => {
        setIsOpen((prevState) =>
            prevState.map((item, idx) => (idx === index ? !item : false))
        );
    };

    const faqs = [
        {
            question: "How long does CRO take?",
            answer:
                "You can expect noticeable results within 30 to 90 days depending on your website’s complexity and traffic volume."
        },
        {
            question: "What types of websites can benefit from CRO?",
            answer:
                "Any website with traffic can benefit, including e-commerce stores, service sites, real estate portals, and B2B platforms."
        },
        {
            question: "Do you offer CRO in multiple languages?",
            answer:
                "Yes. We tailor CRO strategies for diverse language settings to ensure maximum engagement from all your international users."
        },
        {
            question: "Can CRO improve mobile conversions?",
            answer:
                "Absolutely. Given that a large portion of the global audience browses and shops on mobile, we focus heavily on mobile CRO to improve their experience."
        },
        {
            question: "Is CRO expensive?",
            answer:
                "CRO is one of the most cost-effective ways to increase sales because it improves your existing traffic. We offer flexible, transparent pricing based on your goals."
        },
        {
            question: "What kind of ROI can I expect from CRO?",
            answer:
                "The return on investment varies by industry, but most businesses see significant improvements within the first few optimization cycles. Typical results include increased sales, lower customer acquisition costs, and higher overall profitability."
        },
        {
            question: "Is CRO a one-time project or an ongoing service?",
            answer:
                "CRO is an ongoing process. Consumer behavior, technology, and competition evolve constantly, so regular testing and optimization ensure your website remains effective and profitable over time."
        },
        {
            question: "How do you measure the success of a CRO campaign?",
            answer:
                "We track key metrics such as conversion rate, bounce rate, average session duration, and revenue per visitor. Each test’s outcome is analyzed statistically to ensure changes are producing measurable, long-term improvements."
        },
        {
            question: "How is CRO different from SEO?",
            answer:
                "SEO focuses on bringing traffic to your site, while CRO ensures that the traffic converts into actual leads or sales. Both work best together because SEO attracts visitors and CRO converts them into paying customers."
        }
    ];


    return (
        <div className="w-full Section8 mt-[12%] md:mt-[4%]">
            <div className="w-full section8-container">
                <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
                    <h2 className="leading-[29px] md:leading-[41px] text-[26px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
                        Frequently Asked Questions about CRO Services
                    </h2>
                </div>

                <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
                            style={{
                                background:
                                    "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
                            }}
                        >
                            <div
                                onClick={() => handleFaq(index)}
                                className="question text-[#444444] cursor-pointer flex justify-between items-center"
                            >
                                {faq.question}
                                <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[index] ? "-" : "+"}</b>
                            </div>
                            <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                                <br />
                                <p className="mb-5">{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
